import * as Sentry from '@sentry/browser';
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const BUILD_NUMBER = `${process.env.REACT_APP_HEROKU_APP_NAME}-${process.env.REACT_APP_HEROKU_RELEASE_VERSION}`;

const initSentry = () => {
  if (SENTRY_DSN)
    Sentry.init({
      dsn: SENTRY_DSN,
      release: `${BUILD_NUMBER}-client`,
    });
};

const getSentry = () => Sentry ?? null;

export { getSentry, initSentry };
